<template>
<div class="dialog-box">
  <div class="notice" v-show="list && list.length > 0">
    <div v-for="(item, index) in list" :key="index" class="divClass" :style="{
          backgroundColor: ((item.sendType == '1' && item.type == '1') || item.sendType == '2' || item.sendType == '8') ? '#ed1e14' : (item.sendType == '1' && item.type == '2') ?'#fe861b' : (item.sendType == '3' || item.sendType == '4' || item.sendType == '5')? '#f3c21a': ((item.sendType == null && item.type == '1'))?'#ed1e14':'#fe861b'
        }">
      <div class="header" v-if="item.sendType == '1'">
        <span><span class="iconWarn"><i class="icon iconfont icon-zuoyebaojing" :style="{
                  color: item.type == '1' ? '#ed1e14' : '#fe861b'
                }"></i></span>{{ item.alarmTypeName }}</span>
        <span class="iconClass" @click="close(index, item)"><i class="el-icon-close"></i></span>
      </div>
      <div class="header" v-else>
        <span><span class="iconWarn"><i class="icon iconfont icon-careful-full" :style="{
                  color: item.sendType == '2' ? '#ed1e14' : '#f3c21a'
                }"></i></span>{{ item.sendType == '2'?'运行时态监测异常' : item.sendType == '3'? '运行时态监测执行动作失败':item.sendType == '4'?'运行时态监测失败':item.alarmTypeName}}</span>
        <span class="iconClass" @click="close(index, item)"><i class="el-icon-close"></i></span>
      </div>
      <div class="content">
        <div v-if="(item.sendType == '1' || item.sendType == '8') && item.alarmTypeName != '异常报警' && item.alarmTypeName != '断电报警'">
          <span class="label">{{ item.type == '1' ? '报警' : '预警' }}值：</span>
          <span>{{ item.value ? item.value : item.alarmValue }}</span>
        </div>
        <div v-if="item.sendType == '3' || item.sendType == '4' || item.sendType == '5'">
          <span class="label">失败原因：</span> <span>{{ item.msgContent }}</span>
        </div>
        <div v-if="item.sendType == '2' || item.sendType == '4'">
          <span class="label">应处于状态：</span> <span>{{ item.shouldBeStatus == 'close'?'分闸':item.shouldBeStatus == 'open'?'合闸':item.shouldBeStatus == 'nothing'?'无':item.shouldBeStatus == 'lock'?'分闸脱扣':''}}</span>
        </div>
        <div v-if="item.sendType == '2' || item.sendType == '3' || item.sendType == '4'">
          <span class="label">现在处于：</span> <span>{{ item.pathStatus == 'close'?'分闸':item.pathStatus == 'open'?'合闸':item.pathStatus == 'nothing'?'无':item.pathStatus == 'lock'?'分闸脱扣':item.pathStatus }}</span>
        </div>
        <div v-if="item.sendType == '2' || item.sendType == '3' || item.sendType == '4'">
          <span class="label">执行动作：</span> <span>{{item.executeAction == 'close'?'分闸':item.executeAction == 'open'?'合闸':item.executeAction == 'nothing'?'无':item.executeAction == 'lock'?'分闸脱扣':''}}</span>
        </div>
        <div v-if="item.sendType == '1' && item.alarmTypeName == '异常报警'">
          <span class="label">执行动作：</span> <span>{{item.pathStatus == 'close'?'分闸':item.pathStatus == 'open'?'合闸':''}}</span>
        </div>
        <div v-if="item.sendType == '2' || item.sendType == '3' || item.sendType == '4'">
          <span class="label">运行时态监测名称：</span> <span>{{ item.monitorName }}</span>
        </div>
        <div>
          <span class="label">项目名称：</span> <span>{{ item.rootProjectName }}</span>
        </div>
        <div>
          <span class="label">项目分组：</span>
          <span>{{ item.currentProjectName ? item.currentProjectName : item.projectName }}</span>
        </div>
        <div>
          <span class="label">设备名称：</span> <span>{{ item.eqpName }}</span>
        </div>
        <div v-if="item.majorType == '1' || item.majorType == '10'">
          <span class="label">线路名称：</span> <span>{{ item.pathName }}</span>
        </div>
        <div>
          <span class="label">区域位置：</span> <span>{{ item.eqpAddress }}</span>
        </div>
        <div>
          <span class="label"><span v-if="item.sendType == '1' || item.sendType == '2'">{{ item.type == '1' ? '报警' : '预警' }}</span>时间：</span> <span>{{ item.alarmTime }}</span>
        </div>
      </div>
      <div class="footer" v-if="item.sendType == '3' || item.sendType == '4' || item.sendType == '5'">
        <el-button type="text" size="small" @click="close(index, item)">我知道了</el-button>
      </div>
      <div class="footer" v-else>
        <el-button type="text" size="small" @click="viewClick(index, item)">查看<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </div>
    </div>
    <!-- <webscoket webscoketUrl="/webSocket/" @onMessage="webscoketOnMessage" v-if="webscoketShowStatus"></webscoket> -->
    <mqtt @onMessage="webscoketOnMessage" v-if="webscoketShowStatus"></mqtt>
    <!-- 报警提示音 -->
    <!-- <audio id="id" src="../../assets/audio/audio.mp3" muted></audio> -->
    <audio id="alarmId" src="../../assets/audio/alarm.mp3" muted></audio>
    <audio id="warningId" src="../../assets/audio/warning.mp3" muted></audio>
  </div>
</div>
</template>

<script>
// import Cookies from "js-cookie";
// import webscoket from '@/components/webscoket/webscoket'
import mqtt from '@/components/mqtt/mqtt'
import {
  getUnReadCount,
  alarmNewsAlert,
  delAlertAlarm
} from '@/api/messageCenter/message'
import {
  saveUserProjectSelected,
  getRootByChildForUser
} from '@/api/system/user'
import {
  EventBus
} from '@/eventBus'
// import {getevent} from "@/api/common"
export default {
  components: {
    mqtt
  },
  props: {},
  data() {
    return {
      webscoketShowStatus: true,
      list: [],
      labaShow: '',
      item: ''
    }
  },
  created() {
    this.getUserInfo()
    // console.log(this.webscoketShowStatus, 'webscoketShowStatus外面')
    this.$nextTick(() => {
      this.webscoketOnMessage()
    })
    alarmNewsAlert().then((res) => {
      // console.log('报警弹窗res', res)
      this.list = res.data
    })
  },
  methods: {
    // webscopet 回调
    webscoketOnMessage(data) {
      console.log('消息推送data', data)
      if (data) {
        //塑壳状态更新
        if (data.status) {
          this.$message({
            message: data.content,
            type: 'warning'
          })
          setTimeout(() => {
            location.reload()
          }, 3000)
        } else if (data.payStatus) {
          EventBus.$emit('webscoketOnMessage', data)
        } else {
          //报警预警推送
          // console.log(data, '消息推送')
          this.labaShow = this.$store.state.user.playback
          if (this.labaShow == '1') {
            // console.log('喇叭打开')
            if (data.type == '1') {
              this.$nextTick(() => {
                let audioPlay = document.getElementById('alarmId')
                audioPlay.play()
              })
            } else {
              this.$nextTick(() => {
                let audioPlay = document.getElementById('warningId')
                audioPlay.play()
              })
            }
          } else {
            // console.log('喇叭关闭')
          }
          if (data.first) {
            // console.log('data1111', data)
            this.list.unshift(data)
            // this.labaShow = Cookies.get('labaShow')
          } else {
            // console.log('data2222', data)
            getUnReadCount().then((res) => {
              // console.log(res.data, '报警数量')
              this.$store.commit('SET_UNREAD_COUNT', res.data)
              // console.log(this.$store.state.user.unreadCount, 'unreadCount修改了')
              this.$store.commit('SET_FLICKER', true)
              // console.log(this.$store.state.user.flicker, 'flicker修改了')
            })
          }
        }
      }
    },
    // 获取用户信息
    getUserInfo() {
      // console.log(this.$store.getters.userId)
      this.webscoketShowStatus = true
    },
    //查看
    viewClick(index, item) {
      // console.log(item, 'item11111')
      this.close(index, item)
      if (this.$store.state.user.projectId != item.rootProjectId) {

        let params2 = {
          projectId: item.currentProjectId
        }
        getRootByChildForUser(params2).then((ele) => {
          let params = {
            rootProjectId: ele.data
          }
          saveUserProjectSelected(params).then((res) => {
            this.$store.commit('SET_PROJECT_ID', ele.data)
          })
          // this.$store.commit('SET_PROJECT_ID', item.rootProjectId)
          // console.log('点击报警小弹框详情 更新store', this.$store.state.user.projectId)
        })
      }
      this.$store.commit('SET_EQP_NUMBER', item.eqpNumber)
      if ((item.sendType == '1' || item.sendType == '2' || item.sendType == '8') && item.type == '1') {
        sessionStorage.setItem('eqpNumber', item.eqpNumber)
        sessionStorage.setItem('majorType', item.majorType)
        this.$router.push({
          path: '/safeMonitor/alarmRecord'
          // query: {
          //   eqpNumber: item.eqpNumber,
          //   majorType: item.majorType
          // }
        })
      } else if(item.sendType == '1' && item.type == '2'){
        sessionStorage.setItem('eqpNumber1', item.eqpNumber)
        sessionStorage.setItem('majorType1', item.majorType)
        this.$router.push({
          path: '/safeMonitor/awarningRecord'
          // query: {
          //   eqpNumber: item.eqpNumber,
          //   majorType: item.majorType
          // }
        })
      }
    },
    close(index, item) {
      // console.log(item, 'item')
      delAlertAlarm(item.id).then((res) => {})
      this.list.splice(index, 1)
      this.$store.commit('SET_FLICKER', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-box {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  pointer-events: none;
}

.notice {
  pointer-events: all;
  width: 320px;
  background-color: transparent;
  position: absolute;
  z-index: 99999;
  top: 60px;
  right: 5px;
  /* bottom: 21px; */
  overflow: auto;
  /* height: 200px; */
  /* min-height: 200px; */
  max-height: calc(100% - 71px);
  // pointer-events: none;  使盒子变透明

  // animation:fadenum 5s;
  // @keyframes fadenum{
  //   0%{transform:translateX(300px);}
  // }
  .divClass {
    margin-top: 5px;
    height: auto;
    // border: 1px solid red;
    display: flex;
    flex-direction: column;
    // background-color: #34c294;
    box-shadow: 0px 4px 4px 0px rgba(50, 50, 50, 0.3);
    border-radius: 6px;
    opacity: 0.9;
    color: #ffffff;

    .header {
      height: 40px;
      padding: 10px 10px;
      // border-bottom: 1px solid #eeeeee;
      line-height: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 14px;

      .iconWarn {
        height: 24px;
        width: 24px;
        background-color: #ffffff;
        border-radius: 50%;
        margin: 0 5px;
      }

      .iconClass {
        cursor: pointer;
      }

      i {
        font-size: 14px;
        padding: 3px;
      }
    }

    .content {
      font-size: 12px;
      padding: 0px 10px 5px 10px;
      flex: 1;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;

      div {
        display: flex;
        width: 100%;

        .label {
          display: inline-block;
          width: 63%;
          text-align: right;
          margin-right: 10px;
        }

        span {
          text-align: left;
          width: 99%;
          word-break: break-all;
        }
      }
    }

    .footer {
      font-size: 12px;
      text-align: right;
      // border: 1px solid pink;
      margin-right: 10px;
      margin-bottom: 10px;

      ::v-deep .el-button {
        color: #fff;
        padding: 0;
      }

      // cursor: pointer;
      // width: 100%;
    }
  }
}

::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 8px; // 纵向滚动条 必写
}

::-webkit-scrollbar-thumb {
  background-color: #cdd0d4;
  border-radius: 3px;
}
</style>
